<template>
  <a :href="urlOrPath" class="MenuGroupItem">
    <h6 class="title">{{ title }}</h6>
    <p v-if="description" class="description">{{ description }}</p>
  </a>
</template>

<script>
export default {
  props: {
    urlOrPath: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.MenuGroupItem {
  display: block;
}
.title {
  font-size: var(--title-font-size);
  color: var(--menu-text-color-dark);
}
.MenuGroupItem:hover .title {
  color: var(--menu-link-hover-color);
}
.description {
  margin-top: 0.4rem;
  color: var(--menu-text-color-light);
  transition: color 0.15s;
}
</style>
